import ShopThisStoreCategories from './categories';

export default ShopThisStoreCategories;
